<div class="wrapper">
  <img
    class="closeClass cursor-pointer"
    src="../../../../assets/icons/svg/close.svg"
    alt="close"
    height="30"
    width="30"
    (click)="close()"
    (keydown)="close()"
  />
  <div class="pt-4 HeaderClass pb-1">Select Organization</div>
  <div class="pt-2 HeaderClass-subtitle pb-4">
    *The below organization(s) were found. Please select one to continue.
  </div>

  <mat-form-field floatLabel="always" class="org-selection-form">
    <div class="align-arrow">
      <mat-select
        #viewSelect
        class="mater-selection org-selection-dropdown"
        panelClass="testClass1"
        name="organization"
        placeholder="Select organization"
        id="organization"
        [(ngModel)]="orgId"
        [ngClass]="{
          'rotate-down-arrow-icon': viewSelect.panelOpen
        }"
      >
        <label class="align-arrow">
          <input
            id="search-organization"
            class="input-style border-bottom"
            type="text"
            placeholder="Search here"
            [formControl]="orgCtrl"
          />
          <img
            class="icon-color me-2"
            src="../../../assets/icons/svg/search-icon.png"
            alt="search"
            height="30"
            width="30"
          />
        </label>
        <ng-scrollbar
          appearance="compact"
          [autoHeightDisabled]="true"
          [autoWidthDisabled]="true"
          class="scroll-container hgt-200px"
        >
          <mat-option
            *ngFor="let org of filteredOrganizations | async"
            [value]="org.orgId"
          >
            {{ org.orgName }}
          </mat-option>
        </ng-scrollbar>
      </mat-select>
    </div>
  </mat-form-field>

  <div class="buttondiv pt-2">
    <button
      type="submit"
      class="save-button mb-1"
      (click)="onSubmit()"
      [class.disabled]="orgId == 0"
    >
      Continue
    </button>
  </div>
</div>
